<template>
  <div class="general-info">
    <div
      class="statistics-container row rounded bg-secondary-3 py-4 px-4 align-items-strech mx-0 mb-4"
    >
      <div class="col-12 col-md-2 d-flex align-items-center border-right">
        <span class="title">Estadísticas</span>
      </div>
      <div
        v-for="(item, idx) of statistics"
        :key="`item-${idx}`"
        class="col-12 col-md d-flex justify-content-center align-items-center"
      >
        <div class="icon-container">
          <em class="color-gray-5" :class="item.icon" />
        </div>
        <span class="counter">
          {{ item.quantity }}
        </span>
        <div class="d-flex flex-column font-12">
          <span class="color-gray-6">{{ item.title }}</span>
          <span class="font-italic color-gray-6">
            {{ item.lastWeek | quantity }} última semana
          </span>
        </div>
      </div>
    </div>
    <section-title title="Información General" has-line />
    <div class="row mx-0">
      <div class="col-12 mb-3 col-md-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="value.application"
            label="Aplicación:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            :options="options.applications"
            :clearable="false"
            :disabled="readonly"
            :error="errors[0]"
            custom-error-msg="La aplicación es requerida."
            @input="onAppChange"
          />
        </validation-provider>
      </div>
      <div class="col-12 mb-3 col-md-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="value.module"
            label="Módulo:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            :options="options.modules"
            :clearable="false"
            :disabled="readonly || options.modules.length === 0"
            :error="errors[0]"
            custom-error-msg="El módulo es requerido."
            @input="onModuleChange"
          />
        </validation-provider>
      </div>
      <div class="col-12 mb-3 col-md">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="value.link"
            label="Enlace:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            :clearable="false"
            :options="options.links"
            :disabled="readonly || options.links.length === 0"
            :error="errors[0]"
            custom-error-msg="El enlace es requerido."
          />
        </validation-provider>
      </div>
      <div class="col-12 mb-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="value.title"
            label="Título:"
            :disabled="readonly"
            :error="errors[0]"
            custom-error-msg="El título es requerido."
          />
        </validation-provider>
      </div>
      <div class="col-12 mb-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="value.description"
            label="Descripción:"
            :disabled="readonly"
            :maxlength="3000"
            show-char-count
            :count-classes="['d-block text-right']"
            :error="errors[0]"
            custom-error-msg="La descripción es requerida."
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import CustomInput from 'CustomInput';

const quantity = (value) => value.toLocaleString('en-US');

export default {
  name: 'GeneralInfo',
  filters: { quantity },
  components: { SectionTitle, CustomDropDown, CustomTextArea, CustomInput },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    statistics: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onModuleChange(value) {
      this.$emit('module-changed', value);
    },
    onAppChange(value) {
      this.$emit('app-changed', value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';

.general-info {
  .statistics-container {
    .title {
      font-size: 1.125rem;
      color: map-get($colors, 'gray-7');
      font-weight: bold;
      align-self: center;
    }
    .icon-container {
      display: inline-flex;
      border: 1px solid map-get($colors, 'gray-5');
      border-radius: 50%;
      background: map-get($colors, 'white');
      padding: 0.5rem;
    }
    .counter {
      font-size: 1.8125rem;
      font-weight: bold;
      color: map-get($colors, 'green');
      margin-left: 0.5rem;
      margin-right: 1rem;
    }
  }
}
</style>
